import React from 'react';
import { fmtShortDateTimeOrEmpty } from '../../utils/format';

export function isUserTranscriptMessage(message) {
  return message?.direction === 'user' || message?.direction === 'inbound';
}

export function transcriptRoleLabel(message) {
  return isUserTranscriptMessage(message) ? 'user' : 'assistant';
}

export function AssistantTranscriptList({
  emptyLabel = 'No messages stored for this conversation.',
  gap = 8,
  gridTemplateColumns = '90px 1fr 110px',
  messages,
  renderDetails,
  renderMeta,
  rowStyle,
}) {
  if (!messages.length) {
    return (
      <div className="muted" style={{ padding: 28, textAlign: 'center', fontSize: 12.5 }}>
        {emptyLabel}
      </div>
    );
  }

  return (
    <div style={{ display: 'grid', gap }}>
      {messages.map((message) => {
        const isUser = isUserTranscriptMessage(message);
        return (
          <div
            key={message.id}
            style={{
              display: 'grid',
              gridTemplateColumns,
              gap: 10,
              alignItems: 'start',
              fontSize: 12,
              padding: '8px 10px',
              background: 'var(--surface-alpha-primary)',
              borderRadius: 6,
              ...rowStyle,
            }}
          >
            <span className={`chip ${isUser ? 'gray' : 'purple'}`} style={{ justifyContent: 'center' }}>
              {transcriptRoleLabel(message)}
            </span>
            <div style={{ minWidth: 0 }}>
              <div style={{ color: 'var(--text-primary)', whiteSpace: 'pre-wrap', wordBreak: 'break-word', lineHeight: 1.45 }}>
                {message.text || 'No text payload'}
              </div>
              {renderDetails?.(message)}
            </div>
            <div
              className="muted mono"
              style={{
                textAlign: 'right',
                fontSize: 10.5,
                minWidth: 0,
                overflow: 'hidden',
              }}
            >
              {renderMeta ? renderMeta(message) : fmtShortDateTimeOrEmpty(message.createdAt)}
            </div>
          </div>
        );
      })}
    </div>
  );
}

export function AssistantTranscriptCard({ messages }) {
  if (!messages.length) return null;

  return (
    <div className="card" style={{ padding: 18, marginBottom: 18 }}>
      <div className="muted" style={{ fontSize: 11, textTransform: 'uppercase', letterSpacing: 0.6, marginBottom: 10 }}>
        Assistant transcript ({messages.length})
      </div>
      <AssistantTranscriptList messages={messages} />
    </div>
  );
}
